export const TILE_ASPECT_RATIO = 16 / 9;

export function getTracks(participant) {
  return Array.from(participant.tracks.values())
    .filter(function(publication) {
      return publication.track;
    })
    .map(function(publication) {
      return publication.track;
    });
}

export function detachParticipantTracks(participant) {
  var tracks = getTracks(participant);
  tracks.forEach(detachTrack);
}

export function detachTrack(track) {
  track.detach();
}

export function calculateThumbnailSizeForTileView({
                                                    columns,
                                                    visibleRows,
                                                    clientWidth,
                                                    clientHeight
                                                  }) {
  // The distance from the top and bottom of the screen, as set by CSS, to
  // avoid overlapping UI elements.
  const topBottomPadding = 50;

  // Minimum space to keep between the sides of the tiles and the sides
  // of the window.
  const sideMargins = 30 * 2;

  const verticalMargins = visibleRows * 10;
  const viewWidth = clientWidth - sideMargins;
  const viewHeight = clientHeight - topBottomPadding - verticalMargins;
  const initialWidth = viewWidth / columns;
  const aspectRatioHeight = initialWidth / TILE_ASPECT_RATIO;
  const height = Math.floor(Math.min(aspectRatioHeight, viewHeight / visibleRows));
  const width = Math.floor(TILE_ASPECT_RATIO * height);

  return {
    height,
    width
  };
}

export function getTileViewGridDimensions(numberOfParticipants, maxColumns) {
  const columnsToMaintainASquare = Math.ceil(Math.sqrt(numberOfParticipants));
  const columns = Math.min(columnsToMaintainASquare, maxColumns);
  const rows = Math.ceil(numberOfParticipants / columns);
  const visibleRows = Math.min(maxColumns, rows);

  return {
    columns,
    visibleRows
  };
}


